export { default as Header } from '@/components/Home/Header';
export { default as Intro } from '@/components/Home/Intro';
export { default as Overview } from '@/components/Home/Overview';
export { default as BrandVideos } from '@/components/Home/BrandVideos';
export { default as SignUp } from '@/components/Home/SignUp';
export { default as PlatformSteps } from '@/components/Home/PlatformSteps';
export { default as TargetUsers } from '@/components/Home/TargetUsers';
export { default as Trustpilot } from '@/components/Home/Trustpilot';
